import React, { Component } from 'react';
import { Translate } from '_translations';
import { logActivity } from '_analytics/analytics-logger';
import { ACTIVITY_TYPES } from '_enums/activity-types';
import { PAGE_TYPES } from '_enums/page-types';
import { BASE_IMAGE_URL } from '_utils';

import * as basicLightBox from 'basiclightbox';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import GridItem from './GridItem';

class Grid extends Component {
  constructor() {
    super();

    this.lightboxes = [];
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
    this.closeAllLightboxes();
  }

  render() {
    if (this.props.media.contentLoading === false && this.props.media.content.mediaItems.length === 0) {
      return (
        <div className="no-items">
          <Translate resourceString="Pitstop.NothingFoundError" />
        </div>
      );
    }

    const bannerMediaItems = this.props.media.content.mediaItems
      .filter(x => x.mediaItems.length > 0)
      .map((x, index) => (
        <GridItem
          key={index}
          index={index}
          backgroundMediaItem={true}
          createImageLightbox={this.createImageLightbox}
          createVideoLightbox={this.createVideoLightbox}
          {...x}
        />
      ));

    return (
      <React.Fragment>
        <div className="thunderbolt__gallery-fixed-container">
          {bannerMediaItems.slice(0, this.props.getSplicedMediaItemIndex())}
        </div>

        {this.renderBanner()}

        <div className="thunderbolt__gallery-fixed-container grid-container">
          {bannerMediaItems.slice(this.props.getSplicedMediaItemIndex(), this.props.media.content.mediaItems.length)}
        </div>
      </React.Fragment>
    );
  }

  renderBanner = () => {
    if (this.props.showBanner === false || this.props.media.content.mediaItems.length === 0) {
      return null;
    }

    return (
      <div className="thunderbolt__gallery-fixed-image">
        <div
          className="page-banner"
          style={{ backgroundImage: `url(${this.props.page.content.contentFields.bannerImageDesktop})` }}
        />
        <div className="page-product">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={this.props.page.content.contentFields.productLink}
            onClick={e => this.handleProductClick(e)}
          >
            <img src={this.props.page.content.contentFields.productImage} />
            <h2>{this.props.page.content.contentFields.productTitle}</h2>
          </a>
        </div>
      </div>
    );
  };

  createImageLightbox = (e, url) => {
    e.stopPropagation();

    const options = {
      onShow: () => disableBodyScroll(),
      onClose: () => enableBodyScroll(),
    };

    const lightbox = basicLightBox.create(
      `
    <img src="${BASE_IMAGE_URL}${url}?width=1000" />
  `,
      options,
    );

    this.lightboxes.push(lightbox);
    lightbox.show();
  };

  createVideoLightbox = (e, url) => {
    e.stopPropagation();

    const options = {
      onShow: () => disableBodyScroll(),
      onClose: () => enableBodyScroll(),
    };

    const lightbox = basicLightBox.create(
      `
      <video controls autoplay>
        <source src="${url}">
      </video>
    `,
      options,
    );

    this.lightboxes.push(lightbox);
    lightbox.show();
  };

  closeAllLightboxes = () => {
    for (let index = 0; index < this.lightboxes.length; index++) {
      const lightbox = this.lightboxes[index];
      lightbox.close();
    }
  };

  // eslint-disable-next-line
  handleProductClick = event => {
    logActivity({
      activityType: ACTIVITY_TYPES.WRENCH_PRODUCT_VIEW,
      activityCulture: this.props.cultureCode,
      activityValue1: event.currentTarget.getAttribute('href'),
      activityValue2: PAGE_TYPES.GALLERY,
    });
  };
}

export default Grid;
